module.exports = __webpack_public_path__ + "media/customizations/bellavara/back-b498df7ace341f9d0edb04faaada8d97.jpg";